export default {
  card: {
    report: 'Report',
    verifiedPurchase: 'Verified Purchase',
    voteCount: {
      one: '{{count}} person found this helpful',
      other: '{{count}} people found this helpful',
    },
  },
  flagReview: {
    form: {
      buttonText: 'Submit',
    },
  },
  header: {
    subtitle: '{{averageRating}} out of 5 based on {{count}} reviews',
    title: 'Product Reviews',
  },
  searchInput: {
    placeholder: 'Search product reviews',
  },
  voteButton: {
    helpful: 'Helpful',
  },
};
